<template>
  <v-row>
    <v-col cols="12" lg="12" md="12">
      <v-card flat>
        <v-data-table :headers="headers" :items="scales" multi-sort :search="search">
          <template v-slot:top>
            <v-text-field v-model="search" label="Pesquisar" class="mx-4"></v-text-field>
          </template>
          <template v-slot:[`item.department`]="{ item }">
            <td>
              {{ GET_departmentById(item.department_id).department }}
            </td>
          </template>
          <template v-slot:[`item.status_name`]="{ item }">
            <td>
              <small
                class="rounded px-2 py-1 white--text"
                :class="item.status_name === 'Cancelado' ? 'red' : 'success'"
              >
                {{ item.status_name.toUpperCase() }}
              </small>
            </td>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn :key="item.id" icon link large text @click="downloadPdf(item.id)">
              <v-icon large color="blue">mdi-cloud-download</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'ScaleList',
  components: {
    // ScaleFormCreate
  },
  data: function () {
    return {
      search: '',
      headers: [
        { text: 'MÊS', sortable: false, value: 'month_name' },
        { text: 'ANO', value: 'year' },
        { text: 'SETOR', value: 'department' },
        { text: 'STATUS', value: 'status_name' },
        { text: 'AÇÕES', value: 'actions' },
      ],
    }
  },
  computed: {
    ...mapGetters('utils', ['GET_departmentById']),
    ...mapState('employees', ['scales']),
    ...mapState('utils', ['departments']),
  },
  methods: {
    ...mapActions('employees', ['ActionDownloadScalePDF']),
    async downloadPdf(scale_id) {
      await this.ActionDownloadScalePDF(scale_id)
    },
  },
}
</script>
